import { t } from "ttag";

import { UpsellCard } from "metabase/admin/upsells/components";

import { UPGRADE_URL } from "./constants";

export function UpsellMetabaseBanner() {
  return (
    <></>
  );
}
